namespace TabAurous.ProductDevelopment {
    export namespace CustomerRequirementItemsService {
        export const baseUrl = 'ProductDevelopment/CustomerRequirementItems';

        export declare function Create(request: Serenity.SaveRequest<CustomerRequirementItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CustomerRequirementItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CustomerRequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RefNoList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PDInterfaceList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateStatus(request: Serenity.SaveRequest<CustomerRequirementItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/CustomerRequirementItems/Create",
            Update = "ProductDevelopment/CustomerRequirementItems/Update",
            Delete = "ProductDevelopment/CustomerRequirementItems/Delete",
            Retrieve = "ProductDevelopment/CustomerRequirementItems/Retrieve",
            List = "ProductDevelopment/CustomerRequirementItems/List",
            CustomList = "ProductDevelopment/CustomerRequirementItems/CustomList",
            RefNoList = "ProductDevelopment/CustomerRequirementItems/RefNoList",
            PDInterfaceList = "ProductDevelopment/CustomerRequirementItems/PDInterfaceList",
            UpdateStatus = "ProductDevelopment/CustomerRequirementItems/UpdateStatus"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'RefNoList', 
            'PDInterfaceList', 
            'UpdateStatus'
        ].forEach(x => {
            (<any>CustomerRequirementItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
